export enum LoanSimulationQueryStrings {
  CREDIT_LINE_ID = 'creditLineId',
  DOCUMENT = 'document',
  AMOUNT = 'amount',
  ASSISTED_SALE = 'assistedSale',
}
